/*eslint-disable*/
import { HonestSelectInput } from '../../../components/HonestSelect/HonestSelectInput'
import { Input } from '../../../components/Input/Input'
import { Animation, Button, ButtonsContainer, Flex, ItemsGrid, TabFooter } from '../../../styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { ISelectValue } from 'constants/globalTypes'
import { standardFieldValidation, validateSelect } from 'utils/validationUtils'
import { IItemsTab } from 'types/inventory.interface'
import { costingMethodOptions, expiryPolicyOptions, lifeCycleStartSources, lifeCycleTypes, trackingModeOptions } from './itemsData'
import { itemsValidationList } from './itemsValidation'

export const InventoryItemsTrackingTab = ({
  state,
  setState,
  setActive,
  invalidFields,
  setInvalidFields
}: IItemsTab) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    if (itemsValidationList.includes(name)) {
      standardFieldValidation(e, setInvalidFields)

    }
    setState((prev) => ({ ...prev, [name]: value }))
  }

  const handleSelect = async (value: ISelectValue, name: string) => {
    if (itemsValidationList.includes(name)) {
      validateSelect(value, name, setInvalidFields)
    }
    const copy = structuredClone(state)
    copy[name] = value
    setState(copy)
  }

  const handleNext = () => {
    setActive('Machines')
  }

  return (
    <Animation>
      <Flex column width='100%' >
        <ItemsGrid columns={3} gap='0 1.5rem'>
          <HonestSelectInput
            onChange={handleSelect}
            options={trackingModeOptions}
            name='trackingMode'
            defaultValue={state?.trackingMode?.value}
            labelText='Tracking Mode'
            invalid={invalidFields.includes('trackingMode') ? 'true' : ''}
            required
          />

          <HonestSelectInput
            onChange={handleSelect}
            options={costingMethodOptions}
            name='costingMethod'
            defaultValue={state?.costingMethod?.value}
            labelText='Costing Method'
            invalid={invalidFields.includes('costingMethod') ? 'true' : ''}
            required
          />

          <Input
            value={state?.standardCost}
            name='standardCost'
            onChange={handleChange}
            type='number'
            placeholder='120'
            labelText='Standard Cost'
          />

          <HonestSelectInput
            onChange={handleSelect}
            options={lifeCycleTypes}
            name='lifecycleExpirationType'
            defaultValue={state?.lifecycleExpirationType?.value}
            labelText='Lifecycle Expiry Type'
          />

          <HonestSelectInput
            onChange={handleSelect}
            options={lifeCycleStartSources}
            name='lifecycleStartSourceType'
            defaultValue={state?.lifecycleStartSourceType?.value}
            labelText='Lifecycle Start Source'
          />

          <HonestSelectInput
            onChange={handleSelect}
            options={expiryPolicyOptions}
            name='expiryPolicy'
            defaultValue={state?.expiryPolicy?.value}
            labelText='Expiry Policy'
            required
          />
          <Input
            value={state?.warrantyMonths}
            name='warrantyMonths'
            onChange={handleChange}
            type='number'
            placeholder='12'
            labelText='Warranty Months'
          />
        </ItemsGrid>

      </Flex>



      <TabFooter >
        <ButtonsContainer>
          <CancelBtn />
          <Button orange onClick={handleNext}>
            Next
          </Button>
        </ButtonsContainer>
      </TabFooter>
    </Animation>
  )
}
